module.exports = __webpack_public_path__ + "static/media/thumb4.0335a539.png";